const WIDGET_URL = 'https://elevateoshub.com/embed/widget'

// ponytail: the hub resolves the property from the email when propertyId is absent, so an
// unresolved building drops the param instead of sending `propertyId=undefined`.
export const buildWidgetUrl = (email: string, propertyId?: number) => {
  const params = new URLSearchParams({ email })
  if (propertyId) params.set('propertyId', String(propertyId))

  return `${WIDGET_URL}?${params}`
}
